import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function ReclaimedWaterIcon(props: SvgIconProps) {
  return (
    <svg width={281} height={281} viewBox="0 0 281 281" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="1.5"
        y="1.5"
        width={278}
        height={278}
        rx="8.5"
        fill="url(#paint0_linear_225_86968)"
        stroke="white"
        strokeWidth={3}
      />
      <path
        d="M140 189.984C123.822 189.984 108.306 183.537 96.8665 172.061C85.4268 160.585 79 145.02 79 128.79C79 102.003 99.6638 80.5775 117.834 60.942L140 37L162.166 60.942C180.336 80.5852 201 102.011 201 128.79C201 145.02 194.573 160.585 183.134 172.061C171.694 183.537 156.178 189.984 140 189.984Z"
        stroke="white"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <mask id="path-3-inside-1_225_86968" fill="white">
        <path d="M143.999 169.223C137.402 169.834 130.756 168.817 124.644 166.261C118.532 163.705 113.14 159.689 108.942 154.564L113.918 150.488C117.449 154.798 121.984 158.177 127.125 160.327C132.267 162.476 137.857 163.332 143.406 162.818L143.999 169.223Z" />
      </mask>
      <path
        d="M143.999 169.223C137.402 169.834 130.756 168.817 124.644 166.261C118.532 163.705 113.14 159.689 108.942 154.564L113.918 150.488C117.449 154.798 121.984 158.177 127.125 160.327C132.267 162.476 137.857 163.332 143.406 162.818L143.999 169.223Z"
        fill="white"
        stroke="white"
        strokeWidth={2}
        mask="url(#path-3-inside-1_225_86968)"
      />
      <path d="M107.525 159.431L104.183 143.529L119.626 148.586L107.525 159.431Z" fill="white" stroke="white" />
      <mask id="path-5-inside-2_225_86968" fill="white">
        <path d="M100.16 134.414C99.2574 127.85 99.9791 121.166 102.262 114.947C104.544 108.727 108.318 103.163 113.253 98.7418L117.545 103.533C113.395 107.251 110.22 111.931 108.3 117.163C106.38 122.394 105.773 128.017 106.532 133.537L100.16 134.414Z" />
      </mask>
      <path
        d="M100.16 134.414C99.2574 127.85 99.9791 121.166 102.262 114.947C104.544 108.727 108.318 103.163 113.253 98.7418L117.545 103.533C113.395 107.251 110.22 111.931 108.3 117.163C106.38 122.394 105.773 128.017 106.532 133.537L100.16 134.414Z"
        fill="white"
        stroke="white"
        strokeWidth={2}
        mask="url(#path-5-inside-2_225_86968)"
      />
      <path d="M108.31 97.5419L124.049 93.4995L119.68 109.151L108.31 97.5419Z" fill="white" stroke="white" />
      <mask id="path-7-inside-3_225_86968" fill="white">
        <path d="M180.372 123.379C181.275 129.942 180.553 136.627 178.27 142.846C175.988 149.066 172.214 154.63 167.28 159.051L162.987 154.26C167.137 150.542 170.312 145.862 172.232 140.63C174.152 135.399 174.759 129.776 174 124.256L180.372 123.379Z" />
      </mask>
      <path
        d="M180.372 123.379C181.275 129.942 180.553 136.627 178.27 142.846C175.988 149.066 172.214 154.63 167.28 159.051L162.987 154.26C167.137 150.542 170.312 145.862 172.232 140.63C174.152 135.399 174.759 129.776 174 124.256L180.372 123.379Z"
        fill="white"
        stroke="white"
        strokeWidth={2}
        mask="url(#path-7-inside-3_225_86968)"
      />
      <path d="M172.23 160.267L156.491 164.309L160.86 148.658L172.23 160.267Z" fill="white" stroke="white" />
      <mask id="path-9-inside-4_225_86968" fill="white">
        <path d="M134.752 88.786C141.316 87.8834 148 88.6051 154.22 90.8878C160.439 93.1705 166.003 96.9445 170.424 101.879L165.634 106.171C161.915 102.021 157.235 98.8463 152.003 96.9263C146.772 95.0062 141.149 94.3992 135.629 95.1585L134.752 88.786Z" />
      </mask>
      <path
        d="M134.752 88.786C141.316 87.8834 148 88.6051 154.22 90.8878C160.439 93.1705 166.003 96.9445 170.424 101.879L165.634 106.171C161.915 102.021 157.235 98.8463 152.003 96.9263C146.772 95.0062 141.149 94.3992 135.629 95.1585L134.752 88.786Z"
        fill="white"
        stroke="white"
        strokeWidth={2}
        mask="url(#path-9-inside-4_225_86968)"
      />
      <path d="M171.624 96.9438L175.667 112.683L160.015 108.314L171.624 96.9438Z" fill="white" stroke="white" />
      <path
        d="M55.5025 210.898L96.4713 210.898L96.4712 253.836L92.5337 253.836L92.5337 250.836L59.44 250.836L59.44 253.836L55.5025 253.836L55.5025 210.898ZM92.5338 214.367L59.44 214.367L59.44 247.461L92.5337 247.461L92.5338 214.367ZM66.0025 221.539L85.9244 221.539L85.9244 242.023L82.2681 242.023L82.2681 239.398L69.6587 239.398L69.6587 242.023L66.0025 242.023L66.0025 221.539ZM82.2681 224.82L69.6588 224.82L69.6588 236.117L82.2681 236.117L82.2681 224.82ZM133.328 228.055C137.328 221.117 140.219 214.414 142 207.945L145.797 209.023C144.797 211.914 143.75 214.68 142.656 217.32L163.094 217.32L163.094 220.789L157.586 220.789C157.117 229.836 154.797 237.203 150.625 242.891C153.797 245.703 158.297 248.148 164.125 250.227C163.156 251.445 162.266 252.695 161.453 253.977C155.891 251.602 151.453 248.859 148.141 245.75C145.125 248.719 140.953 251.602 135.625 254.398C134.969 253.367 134.172 252.32 133.234 251.258C138.562 248.586 142.68 245.82 145.586 242.961C141.977 238.445 139.641 232.836 138.578 226.133C137.703 227.836 136.797 229.477 135.859 231.055C135.266 230.148 134.422 229.148 133.328 228.055ZM129.109 208.32L132.672 208.32L132.672 254.117L129.109 254.117L129.109 239.656C127.203 240.719 125.266 241.898 123.297 243.195C122.484 243.789 121.687 244.492 120.906 245.305L118.234 242.164C119.203 241.133 119.687 239.789 119.687 238.133L119.688 214.883L123.25 214.883L123.25 238.883C125.109 237.898 127.062 236.852 129.109 235.742L129.109 208.32ZM153.883 220.789L141.414 220.789C141.867 228.414 144.07 234.836 148.023 240.055C151.586 235.039 153.539 228.617 153.883 220.789ZM202.998 208.273L206.794 208.273L206.794 215.797C208.138 219.453 209.677 222.852 211.412 225.992C214.865 223.117 218.31 219.68 221.748 215.68L224.888 218.492C221.232 222.32 217.373 225.891 213.31 229.203C217.435 235.734 222.482 241.039 228.451 245.117C227.138 246.43 226.076 247.602 225.263 248.633C217.044 242.164 210.888 234.156 206.794 224.609L206.794 246.523C206.794 251.18 204.56 253.508 200.091 253.508C198.716 253.508 196.685 253.492 193.997 253.461C193.841 252.305 193.591 250.898 193.247 249.242C195.747 249.492 197.779 249.617 199.341 249.617C201.779 249.617 202.997 248.445 202.997 246.102L202.998 208.273ZM182.982 223.273L182.982 219.711L199.154 219.711L199.154 223.133C196.498 233.383 191.654 242.164 184.622 249.477C183.56 248.258 182.607 247.305 181.763 246.617C188.826 239.18 193.373 231.398 195.404 223.273L182.982 223.273Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_225_86968"
          x1="140.5"
          y1={0}
          x2="140.5"
          y2={281}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BB5E00" />
          <stop offset={1} stopColor="#1681E1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
